// Carrossel categorias
(function () {
  'use strict';
  /* $('.carousel-templates-cat').slick({
    variableWidth: true,
    infinite: false,
    autoplay: false,
    arrows: false,
  }); */
})();

// Ao selecionar um tema
(function () {
  'use strict';
  $('.bl-template-list input[type="radio"]').on('change', function () {
    if ($('input[name="acao"]').val() == 'update') {
      showConfirm({
        type: 'danger',
        title: 'Alteração do Tema',
        text: 'Deseja realmente alterar o tema desta Landing Page? Ao confirmar, toda a personalização realizada no tema anterior será perdida!',
        confirmButtonText: 'Alterar',
        cancelButtonText: 'Cancelar',
        callback: function () {
          handleCheckedTheme();
          smoothScroll('.next-step-scroll', $('.main-header').height());
        },
      });
    } else {
      handleCheckedTheme();
      smoothScroll('.next-step-scroll', $('.main-header').height());
    }
  });
  if ($('.bl-template-list').length > 0) {
    handleCheckedTheme();
  }
  function handleCheckedTheme() {
    const $themeCheckedInput = $('.bl-template-list input[type="radio"]:checked');
    const type = $themeCheckedInput.data('type');
    $('#tipo').val(type);
    $('.bl-template-btns label.btn').text('Selecionar');
    $themeCheckedInput.next('.bl-template').find('.bl-template-btns label.btn').text('Tema Atual');
    if (type == 'default' || type == 'checkout' || type == 'vsl') {
      $('.lp-product-sec').show();
      $('.lp-store-wrp').show();
      $('#product_id').prop('required', true).parsley().reset();
      $('#store').prop('required', true).parsley().reset();
    } else {
      $('.lp-product-sec').hide();
      $('.lp-store-wrp').hide();
      $('#product_id').prop('required', false).parsley().reset();
      $('#store').prop('required', false).parsley().reset();
    }
  }
})();

// Despublicar Landing Page
(function () {
  'use strict';

  // Variáveis
  const $btnDespublicar = $('.btn-despublicar-lp');
  const $formDespublicar = $('#form-despublicar-lp');

  // Ao clicar para despublicar
  $btnDespublicar.on('click', function (ev) {
    ev.preventDefault();
    $('#dplp_registro').val($(this).data('registro'));
    showConfirm({
      type: 'danger',
      title: 'Despublicar Página',
      text: 'Deseja despublicar esta Landing Page?',
      confirmButtonText: 'Despublicar',
      cancelButtonText: 'Cancelar',
      callback: function () {
        $formDespublicar.submit();
      },
    });
  });
})();

// Publicar Landing Page
(function () {
  'use strict';

  // Variáveis
  const $btnOpenModal = $('.btn-publicar-lp');
  const $formPub = $('#form-publicar-lp');
  const $modalPubLp = $('#modal-publicar-lp');
  const $dominiosLista = $('#dominios_list');
  const $campoDominio = $('#mplp_domain');
  const $campoPag = $('#cat_pag');
  const $campoPagLbl = $('label[for="cat_pag"] .label-txt');
  const $domainPreview = $('.lp-url-preview-domain');
  const $pagePreview = $('.lp-url-preview-pag');
  let dominiosLista = [];
  let domainLP;

  if ($modalPubLp.length > 0) {
    // Carrega a lista de domínios
    dominiosLista = $dominiosLista.val() ? JSON.parse($dominiosLista.val()) : [];

    // Ao clicar no botão para abrir o modal
    $btnOpenModal.on('click', function (ev) {
      ev.preventDefault();
      const $btn = $(this);
      /* if ($('#credit_card_gateway').length > 0) {
        const creditCardGateway = $('#credit_card_gateway').val();
        const ticketCardGateway = $('#boleto_gateway').val();
        const pixCardGateway = $('#pix_gateway').val();
        const tipoFrete = $('#tipo_frete').val();
        if (!creditCardGateway && !ticketCardGateway && !pixCardGateway) {
          Toast.fire({
            type: 'warning',
            title: 'Selecione o gateway de pagamento que será utilizado na loja e clique em "Salvar Alterações".',
          });
          return false;
        }
        if (!tipoFrete) {
          Toast.fire({
            type: 'warning',
            title: 'Selecione o tipo de frete padrão que será utilizado na loja e clique em "Salvar Alterações".',
          });
          return false;
        }
      } */
      resetForm();
      $('#mplp_title').text($btn.data('titulo'));
      $('#mplp_registro').val($btn.data('registro'));
      $('#mplp_type').val($btn.data('type'));
      if (dominioJaUtilizado(domainLP, dominiosLista)) {
        $campoPag.val($btn.data('seo-url')).trigger('change');
      }
      $modalPubLp.modal('show');
    });

    // Ao selecionar um domínio
    $campoDominio.on('change', handleDomainLp);
    $campoPag.parsley().on('field:ajaxoptions', function (instance, ajaxOptions) {
      ajaxOptions.data.domain = domainLP;
    });

    // Ao alterar a url da página
    $campoPag.on('input change', handlePagLp);

    // Ao alterar o domínio
    handleDomainLp();
    function handleDomainLp() {
      domainLP = $campoDominio.val();
      let domainInfos = getDominioInfos(domainLP, dominiosLista);
      console.log(domainInfos);
      if (domainInfos) {
        if (domainInfos.total_empty > 0) {
          $campoPagLbl.text('Link da página');
          $campoPag.prop('required', true);
        } else {
          $campoPagLbl.html('Link da página <span class="lbl-help">(Opcional)</span>');
          $campoPag.prop('required', false);
        }
        $campoPag.parsley().reset();
        $domainPreview.text($campoDominio.find('option:selected').text());
      }
    }

    // Ao alterar a url da página
    handlePagLp();
    function handlePagLp() {
      let pag = $campoPag.val();
      $pagePreview.text(pag);
    }

    // Verifica se o domínio já foi utilizado em outra página
    function dominioJaUtilizado(dominio, lista) {
      let dominioInfos = getDominioInfos(dominio, lista);
      if (dominioInfos) {
        return dominioInfos.total_lp > 0;
      }
      return false;
    }

    // Retorna as informações de um domínio
    function getDominioInfos(dominio, lista) {
      if (lista && lista.length > 0) {
        let dominioInfos = lista.filter((item) => item.dominio === dominio)[0];
        if (dominioInfos) {
          return dominioInfos;
        }
      }
      return false;
    }

    // Reset o formulário
    function resetForm() {
      $('#mplp_registro').val('');
      $campoPag.val('');
      $campoDominio.val($campoDominio.find('option').first().val());
      $domainPreview.text($campoDominio.find('option').first().text());
      $pagePreview.text('');
      $formPub.parsley().reset();
    }
  }
})();

// Exibe a confirmação de publicação
function showPagePubli() {
  $('#modal-publicada-lp').modal('show');
  const $animation = $('.lp-publicada-animation');
  const animation = bodymovin.loadAnimation({
    container: $animation[0],
    renderer: 'svg',
    loop: false,
    autoplay: true,
    prerender: true,
    path: $animation.data('json'),
  });
  animation.setSpeed(1.5);
}

// Duplicar Landing Page
(function () {
  'use strict';

  $('.btn-duplicar-lp').on('click', function (ev) {
    ev.preventDefault();
    const registro = $(this).data('registro');
    showConfirm({
      type: 'default',
      title: 'Duplicar Landing Page',
      text: 'Deseja duplicar esta Landing Page?',
      confirmButtonText: 'Duplicar',
      cancelButtonText: 'Cancelar',
      callback: function () {
        duplicarLp(registro);
      },
    });
  });

  function duplicarLp(idLanding) {
    $.ajax({
      url: $('#form-multiplos').attr('action'),
      type: 'post',
      data: {
        landing: idLanding,
        acao: 'duplicar',
      },
      cache: false,
      beforeSend: function () {
        showLoader();
      },
      success: function (resp) {
        console.log(resp);
        hideLoader();
        try {
          resp = JSON.parse(resp);
          // Sucesso
          if (resp.status == 'success') {
            location.reload();
          }
          // Erro
          else {
            Toast.fire({
              type: 'error',
              title: 'Não foi possível realizar esta operação.',
            });
          }
        } catch (error) {
          console.log(error);
          Toast.fire({
            type: 'error',
            title: 'Não foi possível realizar esta operação.',
          });
        }
      },
      error: function (xhr, status, exception) {
        console.log(exception);
        hideLoader();
        Toast.fire({
          type: 'error',
          title: 'Não foi possível realizar esta operação.',
        });
      },
    });
  }
})();

// Obter links de compra
(function () {
  'use strict';

  // Variáveis
  const $btnGetLinks = $('[data-get-links-compra]');
  const $modalLinks = $('#modal-links-compra');
  const $listaLinks = $('#lista-links-compra');
  let clipboardBtns = null;

  // Ao clicar para obter os links
  $btnGetLinks.on('click', function (ev) {
    ev.preventDefault();
    const $btn = $(this);
    const lpId = $btn.data('get-links-compra');
    if (lpId) {
      getLinks(lpId);
    }
  });

  // Obtém os links
  function getLinks(lpId) {
    $.ajax({
      url: $('#form-multiplos').attr('action'),
      type: 'post',
      data: {
        landing: lpId,
        acao: 'links_compra',
      },
      cache: false,
      beforeSend: function () {
        showLoader();
      },
      success: function (resp) {
        console.log(resp);
        hideLoader();
        try {
          resp = JSON.parse(resp);
          // Sucesso
          if (resp.status == 'success') {
            populaLinks(resp.lista);
          }
          // Erro
          else {
            Toast.fire({
              type: 'error',
              title: 'Não foi possível realizar esta operação.',
            });
          }
        } catch (error) {
          console.log(error);
          Toast.fire({
            type: 'error',
            title: 'Não foi possível realizar esta operação.',
          });
        }
      },
      error: function (xhr, status, exception) {
        console.log(exception);
        hideLoader();
        Toast.fire({
          type: 'error',
          title: 'Não foi possível realizar esta operação.',
        });
      },
    });
  }

  // Popula links
  function populaLinks(links) {
    $listaLinks.html('');
    links.forEach((link) => {
      $listaLinks.append(`
      <tr>
        <td>
          <div class="prod-table-infos">
            <img src="${link.image}" alt="${link.title}" class="img-fluid rounded border mr-3" width="50px">
            <div>
              <div><b>${limitText(link.title, 50)}</b></div>
              <div>${limitText(link.subtitle, 50)}</div>
            </div>
          </div>
        </td>
        <td width="120px">
          <div class="table-options no-hover">
            <button class="btn btn-sm btn-secondary btn-copy-link" data-toggle="tooltip" data-placement="top" title="Copiar link" data-clipboard-text="${
              link.url
            }"><i class="las la-clipboard mr-1"></i> Copiar</button>
          </div>
        </td>
      </tr>`);
    });
    $modalLinks.modal('show');
  }

  // Botões clipboard
  $modalLinks.on('show.bs.modal', function () {
    initClipboardBtns();
    initTooltips();
  });
  function initClipboardBtns() {
    if (clipboardBtns !== null) {
      clipboardBtns.destroy();
      clipboardBtns = null;
    }
    const $btnsCopy = $modalLinks.find('.btn-copy-link');
    $btnsCopy
      .on('click', function (ev) {
        ev.preventDefault();
      })
      .on('mouseout', function () {
        const $btn = $(this);
        $btn.attr('data-original-title', 'Copiar link');
      });
    clipboardBtns = new ClipboardJS('.btn-copy-link', {
      container: $modalLinks[0],
    });
    clipboardBtns.on('success', function (ev) {
      const $btn = $(ev.trigger);
      $btn.attr('data-original-title', 'Copiado!');
      $btn.tooltip('show');
    });
  }
})();

// ------------------------------------
// Usuários online
// ------------------------------------
(function () {
  'use strict';

  $.ajaxSetup({ cache: false });

  if ($('.dash-users-online.sm, .dash-users-online.store').length > 0) {
    // Variáveis
    const usersOnlineUrl = urlBase + 'core/acoes/app/geral/users_online.php';
    const $userOnlineNumber = $('.dash-users-online-number');
    let isLoading = false;

    $(window).on('load', function () {
      getUsersOnlineByLp();
      const userOnlineInterval = setInterval(getUsersOnlineByLp, 60000);
    });

    function getUsersOnlineByLp() {
      let landingsID = [];
      let storeSlug = '';
      $userOnlineNumber.each(function () {
        const $el = $(this);
        storeSlug = $el.data('store');
        const lpID = $el.data('landing');
        landingsID.push(lpID);
      });
      landingsID = landingsID.join(',');
      getUsersOnline(storeSlug, landingsID);
    }

    // Obtém a quantidade de usuários online
    function getUsersOnline(storeSlug, landingsID) {
      isLoading = true;
      //$el.html('<i class="las la-circle-notch la-spin"></i>');
      $.getJSON(`${usersOnlineUrl}?store_slug=${storeSlug}&landing=${landingsID}`, function (resp) {
        console.log(resp);
        isLoading = false;
        if (resp.length > 0) {
          const landings = resp;
          landings.forEach((lp) => {
            const $el = $('.dash-users-online-number[data-landing="' + lp.landingpage + '"]');
            const visitantesOnline = lp.online;
            $el.html(visitantesOnline);
          });
        } else {
          $userOnlineNumber.html('0');
        }
      }).fail(function (resp) {
        console.log(resp);
        isLoading = false;
        $userOnlineNumber.html('0');
      });
    }
  }
})();
